import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'spt-help-nav-back',
  templateUrl: './help-nav-back.component.html',
  styleUrls: ['./help-nav-back.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpNavBackComponent {}
